const onInvoiceListPageMatch = () => {
  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector('#invoiceList')
    if (pageContent) {
      clearInterval(waitForPageLoad)

      if (typeof window.Lux_refetchInvoiceListEmojiCache === 'function') {
        Promise.resolve(window.Lux_refetchInvoiceListEmojiCache())
          .then(function () {
            if (typeof window.Lux_restoreInvoiceListPropertyEmojis === 'function') {
              window.Lux_restoreInvoiceListPropertyEmojis()
            }
          })
          .catch(function () {
            if (typeof window.Lux_scheduleInvoiceListPropertyEmojiRestore === 'function') {
              window.Lux_scheduleInvoiceListPropertyEmojiRestore()
            }
          })
      } else if (typeof window.Lux_scheduleInvoiceListPropertyEmojiRestore === 'function') {
        window.Lux_scheduleInvoiceListPropertyEmojiRestore()
      }
      if (typeof window.Lux_scheduleInvoiceListPropertyEmojiRestore === 'function') {
        if (!pageContent.dataset.luxInvoiceEmojiObserver) {
          pageContent.dataset.luxInvoiceEmojiObserver = '1'
          const obs = new MutationObserver(() => {
            window.Lux_scheduleInvoiceListPropertyEmojiRestore()
          })
          obs.observe(pageContent, { childList: true, subtree: true, characterData: true })
        }
      }

      const dropdownButton = document.querySelector('.DropdownButton')
      const existingButtonWrapper = document.querySelector('.buttonWrapper')
      if (dropdownButton && !existingButtonWrapper) {
        const buttonWrapper = document.createElement('div')
        buttonWrapper.className = 'buttonWrapper'
        buttonWrapper.style.display = 'flex'
        buttonWrapper.style.flexDirection = 'row'
        buttonWrapper.style.gap = '10px'

        const relevantForMeButton = dropdownButton.cloneNode(true)
        relevantForMeButton.textContent = 'Meine Rechnungen'

        dropdownButton.parentNode.insertBefore(
          buttonWrapper,
          dropdownButton.nextSibling
        )
        buttonWrapper.appendChild(dropdownButton)
        buttonWrapper.appendChild(relevantForMeButton)

        relevantForMeButton.addEventListener('click', () => {
          const url = new URL(window.location.href)
          url.searchParams.set('state', 'RELEVANT_FOR_ME')
          window.history.pushState({}, '', url)
          window.location.reload()
        })
      }
    }
  }, 500)
}
